import styled from 'styled-components';
import { tokens } from '@mindtickle/styles/lib';

export const StyledDropdownActionItemWrapper = styled.div`
  padding: 4px 8px;
  flex: 1;

  &.styled-content {
    padding: 0px 8px 4px;
  }

  .dropdown-action-label {
    cursor: pointer;
    padding: 6px 16px;
    border-radius: 4px;
    transition: background-color 0.3s ease;
  }
  &:hover {
    .dropdown-action-label {
      color: ${tokens.textTokens.COLOR_TEXT_INVERSE};
      background-color: ${tokens.bgTokens.COLOR_BG_ACCENT};
    }
  }

  &.sign-out-action {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 12px;

    .sign-out-label {
      display: flex;
      flex-direction: row-reverse;
      width: 100%;
      justify-content: flex-end;
      align-items: center;
      gap: 8px;
    }
    .sign-out-icon {
      font-size: 16px;
    }

    &:hover {
      .dropdown-action-label {
        background-color: ${tokens.bgTokens.COLOR_BG_DANGER_STRONG};
      }
    }
  }
`;
